import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { fetchProfilesOptions, ProfilesOptionsParams } from "PFCore/services/profile";
import { BasicProfile, Collection } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { profilesKeys } from "./query_keys";

export const useProfilesOptions = <TData = Collection<BasicProfile[]>>(
  params: ProfilesOptionsParams,
  options: QueryOptions<Collection<BasicProfile[]>, AxiosError, TData> = {}
) =>
  useQuery<Collection<BasicProfile[]>, AxiosError, TData>({
    queryKey: profilesKeys.options(params),
    queryFn: () => fetchProfilesOptions(params),
    ...options
  });
